import fetch from './fetch';

import { ENV } from '../settings/env';
import { LOCALE_TRANSLATIONS_URLS } from '../settings/locale';
import { language } from './translator';

export function fetchTranslations(locale) {
  return fetch(LOCALE_TRANSLATIONS_URLS[ENV](locale))
    .then(response => response.json());
}

export function getBrand(locale, cdc) {
  switch (language) {
    case 'ja':
      return cdc ? 'クリスチャン ディオール クチュール' : '香水キリスト教の ディオール';

    case 'ko':
      return cdc ? '크리스챤 디올 꾸뛰르' : '향수 크리스챤 디올';

    default:
      return cdc ? 'Christian Dior Couture' : 'Parfum Christian Dior';
  }
}



// WEBPACK FOOTER //
// ./src/services/locale.js